export default "__VITE_ASSET__969fb2b5__"